import { useCallback, useEffect, useState } from 'react'

export interface SessionUser {
  name: string
  email: string
}

export interface DemoSession {
  isAuthenticated: boolean
  user: SessionUser | null
  csrfToken: string | null
  source: 'demo' | 'account' | null
  enterDemo: () => void
  signOut: () => void
}

const storageKey = 'owners-desk-demo-session'
const demoUser = { name: 'Alex Morgan', email: 'alex@example.com' }

export function useDemoSession(): DemoSession {
  const [user, setUser] = useState<SessionUser | null>(null)
  const [csrfToken, setCsrfToken] = useState<string | null>(null)
  const [source, setSource] = useState<'demo' | 'account' | null>(null)

  useEffect(() => {
    if (window.localStorage.getItem(storageKey) === 'active') {
      setUser(demoUser)
      setSource('demo')
    }
  }, [])

  const enterDemo = useCallback(() => {
    window.localStorage.setItem(storageKey, 'active')
    setUser(demoUser)
    setSource('demo')
  }, [])

  const signOut = useCallback(() => {
    window.localStorage.removeItem(storageKey)
    if (csrfToken) void fetch('/api/auth/logout', { method: 'POST', credentials: 'same-origin', headers: { 'x-csrf-token': csrfToken } })
    setUser(null)
    setCsrfToken(null)
    setSource(null)
    window.location.assign('/')
  }, [csrfToken])

  return { isAuthenticated: Boolean(user), user, csrfToken, source, enterDemo, signOut }
}
